import { sel } from "../../academy/selectors";
import { TutorialDefinition } from "../types";

/**
 * Academy lesson: upload a form template. Started from the lesson page in a new
 * tab; never auto-started. The tour opens the upload dialog and points at the
 * controls, but never picks a file or uploads for the officer.
 */
const tour: TutorialDefinition = {
  id: "upload-a-form-template",
  version: "1.0.0",
  releasedAt: "2026-10-29T00:00:00.000Z",
  category: "onboarding",
  title: "Upload a form template",
  description: "Bring in a department PDF and let the app detect its fields.",
  triggerRoute: /^\/forms(\/.*)?$/,
  startRoute: "/forms",
  lessonId: "upload-a-form-template",
  autoStart: false,
  steps: [
    {
      target: sel("formsUploadButton"),
      waitFor: sel("formsUploadButton"),
      waitTimeoutMs: 10000,
      title: "Upload Template",
      content: "Click this to open the upload dialog.",
      disableBeacon: true,
      placement: "bottom",
      advanceOn: { selector: sel("formsUploadButton"), event: "click" },
      hint: "Click Upload Template to continue",
      spotlightClicks: true,
    },
    {
      target: sel("formUploadDrop"),
      waitFor: sel("formUploadDrop"),
      title: "Choose your PDF",
      content:
        "Click here to pick a PDF, or drag one onto the dialog. A fillable PDF has its fields read out straight away. A flat or scanned one is read by the AI after you upload.",
      disableBeacon: true,
      placement: "bottom",
    },
    {
      target: sel("formUploadScope"),
      waitFor: sel("formUploadScope"),
      waitTimeoutMs: 60000,
      title: "Name, description, scope",
      content:
        "Once a PDF is chosen, name the template and pick a scope. Personal is only for you. Agency shares it with the department.",
      disableBeacon: true,
      placement: "top",
      hint: "Choose a PDF to continue",
    },
    {
      target: sel("formUploadSubmit"),
      waitFor: sel("formUploadSubmit"),
      title: "Upload",
      content:
        "This uploads the PDF and starts reading it. A tray in the corner follows the progress, and the template opens once it is ready. Then use Edit Fields to add anything it missed.",
      disableBeacon: true,
      placement: "top",
    },
  ],
};

export default tour;
